export default __webpack_public_path__ + "content/media/10.e20d586c.jpg";